import React, { memo } from 'react';
import { Typography } from 'common/components';
import { lowerBoundsBreakpoints } from 'common/styles/breakpoints';
import { BaseButton } from 'fronton-react';
import { AdplatformTrainingReelStructure } from '../../adplatform-training-reels-section-constants';
import { reelItem, reelItemImage } from './reel-item-styles';

type ReelItemProps = {
  reel: AdplatformTrainingReelStructure;
  onClick: () => void;
  liClassName?: string;
};

export const ReelItem: React.FC<ReelItemProps> = memo(({ reel, onClick, liClassName }) => (
  <li className={liClassName}>
    <BaseButton
      className={reelItem}
      onClick={onClick}
      href={reel.href}
      target={reel.href ? '_blank' : undefined}>
      <picture>
        <source srcSet={reel.image.srcD} media={lowerBoundsBreakpoints['--from-desktop']} />
        <source srcSet={reel.image.srcT} media={lowerBoundsBreakpoints['--from-tablet']} />
        <img alt={reel.image.alt} title={reel.image.alt} className={reelItemImage} src={reel.image.srcM} />
      </picture>
      <Typography variant="h3">{reel.title}</Typography>
    </BaseButton>
  </li>
));
